var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message && _vm.type==='success')?_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),(_vm.message && _vm.type==='error')?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }